'use strict';

const cssConstants=require("../utils/cssConstants");

module.exports = {
    emailValidation: function () {
        $('#registration-form-email, #login-form-email').on('blur keyup', function (e) {
            var emailVal = $(e.target).val();
            var $formGroup = $(e.target).parents('.form-group');
            var $fieldError = $formGroup.find('.invalid-feedback');
            var $emailMatch = $formGroup.find('.js-email-match');
            var $emailHelper = $formGroup.find('.js-email-helper');
            var $emailHelperList = $formGroup.find('.js-email-helper-list');
            var emailRegExp = /^(?:[\w]+){1}[+\w\.\-]*@(?:[\w\-]+)((\.(\w){2,9})+)$/; // eslint-disable-line no-useless-escape

            if (e.type === 'keyup' && !$(e.target).hasClass(cssConstants.INVALID) && !$(e.target).hasClass(cssConstants.VALID)) {
                return;
            }

            if (!emailVal.match(emailRegExp)) {
                $emailMatch.addClass(cssConstants.SHOW_BLOCK);
            } else {
                $emailMatch.removeClass(cssConstants.SHOW_BLOCK);
            }

            if ($emailHelperList.children('.' + cssConstants.SHOW_BLOCK).length) {
                $emailHelper.removeClass(cssConstants.HIDDEN);
                $(e.target).addClass(cssConstants.INVALID).removeClass(cssConstants.VALID);
                $formGroup.addClass(cssConstants.INVALID);
                $fieldError.addClass(cssConstants.HIDDEN);
            } else {
                $emailHelper.addClass(cssConstants.HIDDEN);
                $(e.target).removeClass(cssConstants.INVALID).addClass(cssConstants.VALID);
                $formGroup.removeClass(cssConstants.INVALID);
            }
        });
    }
};


